import React, { useEffect, useState } from 'react';
import { Box, IconButton, TableCell, TableRow } from '@material-ui/core';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import { IPartnerRatingByPartnerUgo, IRealEstateRatingByPartnerUgo } from '../../../interfaces';
import { INomenclature } from '../interfaces';
import { useExportPartnerRatingUgoByRealEstateExcelReport, useGetRealEstateRatingByPartnerUgo } from '../hooks';
import PartnerRatingByMonthTableRow from './PartnerRatingByMonthTableRow';

interface IProps {
  year: number;
  nomenclature: INomenclature;
  partnerRating: IPartnerRatingByPartnerUgo;
  realEstateRating: IRealEstateRatingByPartnerUgo;
  rowIndex: number;
}

const PartnerRatingTableRow = ({ partnerRating, realEstateRating, nomenclature, year, rowIndex }: IProps) => {
  const [open, setOpen] = useState(false);

  const { criteriaRatings, realEstateName } = realEstateRating;

  const {
    fetchRealEstateRatingUgoByPartner,
    data: realEstateRatingByPartner,
    ...realEstateRatingByPartnerState
  } = useGetRealEstateRatingByPartnerUgo();
  const { exportPartnerRatingUgoByRealEstateExcelReport, ...partnerRatingByRealEstateExcelState } =
    useExportPartnerRatingUgoByRealEstateExcelReport();

  const params = {
    partnerGuid: partnerRating.smrPartnerGuid,
    realEstateGuid: realEstateRating.realEstateGuid,
    nomenclaturaGuid: nomenclature.nomenclaturaGuid,
    year,
  };
  const mapKey = Object.values(params).filter(Boolean).join('-');

  useEffect(() => {
    if (!open) return;
    fetchRealEstateRatingUgoByPartner(partnerRating.smrPartnerGuid, realEstateRating.realEstateGuid, {
      params: { nomenclaturaGuid: nomenclature.nomenclaturaGuid, year },
    });
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const realEstatesRating = realEstateRatingByPartner.get(mapKey) || [];

  return (
    <>
      <TableRow>
        <TableCell>{rowIndex === 0 && <b>ЖК</b>}</TableCell>

        {criteriaRatings.map((criteriaRating) => (
          <TableCell key={criteriaRating.criteriaRatingId} align="center">
            {criteriaRating.criteriaRatingName}
          </TableCell>
        ))}
      </TableRow>

      <TableRow>
        <TableCell style={{ cursor: 'pointer' }} onClick={() => setOpen(!open)}>
          <Box sx={{ display: 'flex', alignItems: 'center', gridGap: 8 }}>
            <b>{realEstateName}</b>

            <IconButton aria-label="Развернуть строку" size="small">
              {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
          </Box>
        </TableCell>

        {criteriaRatings.map((criteriaRating) => (
          <TableCell key={criteriaRating.criteriaRatingId} align="center">
            {criteriaRating.value}
          </TableCell>
        ))}
      </TableRow>

      <PartnerRatingByMonthTableRow
        {...realEstateRatingByPartnerState}
        open={open}
        partnerRating={partnerRating}
        nomenclature={nomenclature}
        realEstatesRating={realEstatesRating}
        exportExcelLoading={partnerRatingByRealEstateExcelState.loading}
        criteriaRatingsCount={criteriaRatings.length + 1}
        onExportExcel={() =>
          exportPartnerRatingUgoByRealEstateExcelReport(partnerRating.smrPartnerGuid, realEstateRating.realEstateGuid, {
            params,
          })
        }
      />
    </>
  );
};

export default PartnerRatingTableRow;
